import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaperkmrateinoune() {



    const cardData =
    {
        keyword: 'Urbania per km rate in Pune',
        heading: 'Urbania on rent in pune: Urbania per km rate in Pune',
        headingDescription: 'Urbania On Rent in Pune offers transparent and competitive Urbania Per Km Rate in Pune for travelers seeking budget-friendly and dependable group transportation across the city and nearby destinations. Our well-maintained Force Urbania fleet provides spacious seating, air-conditioned comfort, and smooth performance, making it ideal for local travel, corporate commutes, airport transfers, family outings, and outstation journeys with clear per-kilometer pricing. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from all major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a cost-effective and stress-free travel experience with Urbania per km rates that suit every budget. Backed by 24/7 booking support, punctual service, and transparent pricing, Urbania On Rent in Pune stands out as the trusted choice for reliable Urbania services at affordable per-km rates in Pune.',

        top: 'Top Places to Visit in Pune with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic historical fort and a powerful symbol of Maratha pride. Once the administrative center of Bajirao I, it features massive stone walls, majestic gates like the Delhi Darwaza, and spacious courtyards. Although a major fire destroyed much of the structure, the remaining fort reflects royal grandeur. The evening light-and-sound show narrates Maratha history, making it a must-visit heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is one of Pune’s most important landmarks connected to India’s freedom struggle. Built in 1892, it served as a prison for Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai during the Quit India Movement. The palace now houses a museum displaying Gandhi’s personal belongings, photographs, and letters. Its Italian-style arches, lush lawns, and peaceful environment make it both historically significant and visually stunning."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most famous and revered Ganesh temple. The idol is richly adorned with gold ornaments and attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the heart of Pune’s grand celebrations with processions and cultural programs. The temple trust is also well known for its social and charitable initiatives, making it spiritually and socially significant."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a historic hill fortress located amidst the Sahyadri ranges and is famous for the legendary battle fought by Tanaji Malusare. The fort offers panoramic views of Pune city, ancient bastions, memorials, and scenic trekking routes. Visitors enjoy traditional Maharashtrian food like pithla-bhakri at the top. It is a perfect destination combining history, adventure, and natural beauty."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut temple dedicated to Lord Shiva, carved from a single basalt rock. It features monolithic pillars, a circular Nandi mandap, and ancient carvings reflecting early Indian craftsmanship. Despite being located in a busy area, the temple maintains a calm and spiritual ambiance, offering a peaceful retreat within the city."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected from across India, showcasing traditional art, musical instruments, sculptures, and household items. One of its highlights is the recreated Mastani Mahal. The museum offers deep insight into India’s cultural heritage and is a treasure trove for history lovers, students, and art enthusiasts."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks and offers breathtaking panoramic views after climbing 103 stone steps. The hilltop Parvati Temple, built during the Peshwa era, is dedicated to Lord Shiva and Goddess Parvati. The complex also includes smaller shrines and a museum. Sunrise and sunset views from the hill are especially captivating."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a globally renowned center for meditation, mindfulness, and wellness. Surrounded by lush gardens, it attracts visitors from around the world seeking peace, relaxation, and self-discovery. The serene atmosphere and unique meditation techniques make it a distinctive spiritual destination in Pune."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped garden. It features flowing water streams, stone bridges, manicured lawns, and seasonal flowers. The garden offers a peaceful environment for walks, photography, and family outings, beautifully blending Japanese aesthetics with Indian natural beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular picnic and leisure spot near Pune. The expansive water body, surrounding hills, and cool breezes create a scenic setting, especially during monsoon and evenings. Local vendors selling corn and tea add to its charm. It also serves as the gateway to Sinhagad Fort, making it a favorite weekend getaway."
  }
],



"services": [
    {
      "name": "Urbania per km rate in Pune",
      "description": "Urbania per km rate in Pune offers flexible and transparent pricing based on distance traveled. This pricing model is ideal for local, outstation, and long-distance journeys, allowing customers to pay only for the kilometers used while enjoying comfortable vehicles and professional chauffeur service."
    },
    {
      "name": "Urbania Hire Price per km Pune",
      "description": "Urbania Hire Price per km Pune provides a clear and cost-effective billing structure for customers seeking reliable transportation. With per kilometer pricing, clients benefit from fair charges, well-maintained vehicles, and experienced drivers suitable for both city and highway travel."
    },
    {
      "name": "Urbania Rental Charges Pune",
      "description": "Urbania Rental Charges Pune are designed to suit different travel needs, including hourly, daily, and per kilometer usage. Pricing remains transparent with no hidden costs, ensuring customers receive value-for-money transportation for family trips, corporate travel, and group outings."
    },
    {
      "name": "Urbania Bus Fare Pune",
      "description": "Urbania Bus Fare Pune offers competitive and affordable rates for group transportation within Pune and nearby locations. With spacious seating, clean interiors, and professional chauffeurs, customers receive reliable service at reasonable fare structures."
    },
    {
      "name": "Urbania AC Bus Rate Pune",
      "description": "Urbania AC Bus Rate Pune provides premium pricing for air-conditioned buses that ensure comfort during travel. Ideal for corporate events, weddings, and long journeys, these rates include enhanced comfort, smooth rides, and professional driver support."
    },
    {
      "name": "Urbania Non AC Bus Rate Pune",
      "description": "Urbania Non AC Bus Rate Pune offers economical pricing for customers seeking budget-friendly group travel. Suitable for short trips and local travel, this option delivers reliable transportation without compromising safety or service quality."
    },
    {
      "name": "Affordable Urbania Rate Pune",
      "description": "Affordable Urbania Rate Pune focuses on delivering quality transportation at cost-effective prices. Ideal for families, small groups, and budget-conscious travelers, these rates ensure comfortable travel with well-maintained vehicles and trained chauffeurs."
    },
    {
      "name": "Corporate Urbania Pricing Pune",
      "description": "Corporate Urbania Pricing Pune provides customized and contract-based pricing solutions for businesses and organizations. Ideal for employee transport, meetings, and events, this pricing ensures professional service, punctuality, and long-term cost efficiency."
    },
    {
      "name": "Outstation Urbania Rate Pune",
      "description": "Outstation Urbania Rate Pune offers structured and competitive pricing for long-distance travel. Designed for intercity trips, pilgrimages, and tours, it includes experienced drivers, highway-ready vehicles, and transparent billing for peace of mind."
    },
    {
      "name": "Urbania Cost per km Pune",
      "description": "Urbania Cost per km Pune provides a simple and flexible pricing method for customers who prefer distance-based billing. This option ensures fair charges, efficient route planning, and reliable transportation for both local and outstation journeys."
    },
    {
      "name": "Best Urbania Price Pune",
      "description": "Best Urbania Price Pune ensures customers receive the most competitive rates without compromising service quality. With well-maintained vehicles, professional chauffeurs, and transparent pricing, it delivers excellent value for every journey."
    },
    {
      "name": "Transparent Urbania Fare Pune",
      "description": "Transparent Urbania Fare Pune emphasizes clear pricing with no hidden charges. Customers are informed upfront about per kilometer rates, driver allowances, and applicable taxes, ensuring trust, clarity, and confidence in the rental service."
    },
    {
      "name": "Urbania Rental Tariff Pune",
      "description": "Urbania Rental Tariff Pune provides detailed pricing structures covering local trips, outstation travel, and long-term rentals. These tariffs are designed to be flexible, competitive, and suitable for individuals, families, and corporate clients."
    },
    {
      "name": "Budget Urbania Hire Pune",
      "description": "Budget Urbania Hire Pune offers economical rental options for customers seeking reliable transportation at lower costs. Ideal for group travel, short trips, and cost-sensitive bookings, it ensures dependable service and comfortable vehicles."
    },
    {
      "name": "Urbania Price List Pune",
      "description": "Urbania Price List Pune provides a comprehensive overview of rental charges, per kilometer rates, and package options. Designed for transparency and convenience, it helps customers choose the most suitable and cost-effective Urbania rental service for their travel needs."
    }
  ],
  "tableData": [
    ["Urbania per km rate in Pune", "Urbania Hire Price per km Pune"],
    ["Urbania Rental Charges Pune", "Urbania Bus Fare Pune"],
    ["Urbania AC Bus Rate Pune", "Urbania Non AC Bus Rate Pune"],
    ["Affordable Urbania Rate Pune", "Corporate Urbania Pricing Pune"],
    ["Outstation Urbania Rate Pune", "Urbania Cost per km Pune"],
    ["Best Urbania Price Pune", "Transparent Urbania Fare Pune"],
    ["Urbania Rental Tariff Pune", "Budget Urbania Hire Pune"],
    ["Urbania Price List Pune", ""]
  ],



"whychoose": [
    {
        "WhyChooseheading": "Affordable Urbania Per Km Rate in Pune",
        "WhyChoosedescription": "Urbania per km rate in Pune offers a cost-effective and flexible pricing option for local, outstation, corporate, and group travel needs."
    },
    {
        "WhyChooseheading": "Transparent Per Km Pricing Structure",
        "WhyChoosedescription": "Urbania per km rate in Pune follows a clear and transparent billing system with no hidden charges, ensuring complete pricing clarity."
    },
    {
        "WhyChooseheading": "Well-Maintained Force Urbania Vehicles",
        "WhyChoosedescription": "Urbania per km rate in Pune includes clean, spacious, and well-maintained Force Urbania vehicles designed for comfortable group travel."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Urbania per km rate in Pune comes with trained and experienced drivers who ensure safe, smooth, and reliable journeys."
    },
    {
        "WhyChooseheading": "Ideal for Local and Outstation Travel",
        "WhyChoosedescription": "Urbania per km rate in Pune is suitable for city travel, airport transfers, corporate trips, weddings, and long-distance outstation journeys."
    },
    {
        "WhyChooseheading": "Flexible Distance-Based Billing",
        "WhyChoosedescription": "Urbania per km rate in Pune allows you to pay only for the distance traveled, making it a budget-friendly choice for all travel plans."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Safe Vehicles",
        "WhyChoosedescription": "All vehicles under Urbania per km rate in Pune are regularly sanitized and serviced to maintain high hygiene and safety standards."
    },
    {
        "WhyChooseheading": "Reliable and Punctual Service",
        "WhyChoosedescription": "Urbania per km rate in Pune ensures on-time pickups and dependable service for stress-free group transportation."
    }
]
}

const faqData = [
    {
        question: 'What is the Urbania per km rate in Pune?',
        answer: 'Urbania per km rate in Pune depends on seating capacity, trip type, and duration. Final rates are shared clearly at the time of booking.',
    },
    {
        question: 'Is Urbania per km rate in Pune applicable for local travel?',
        answer: 'Yes, Urbania per km rate in Pune is available for local city travel, sightseeing, and short-distance trips.',
    },
    {
        question: 'Can I book Urbania per km rate in Pune for outstation travel?',
        answer: 'Absolutely. Urbania per km rate in Pune is ideal for outstation trips, round trips, and multi-day travel.',
    },
    {
        question: 'Are tolls and parking included in the per km rate?',
        answer: 'Toll charges, parking fees, and driver allowance are generally charged extra and shared transparently during booking.',
    },
    {
        question: 'Are drivers included in Urbania per km rate in Pune?',
        answer: 'Yes, Urbania per km rate in Pune includes a professional and experienced driver.',
    },
    {
        question: 'Is Urbania per km rate in Pune available 24x7?',
        answer: 'Yes, Urbania per km rate in Pune is available 24x7 for all travel requirements.',
    },
    {
        question: 'Are vehicles sanitized regularly?',
        answer: 'Yes, all vehicles under Urbania per km rate in Pune are cleaned and sanitized before every trip.',
    },
    {
        question: 'Can pickup and drop locations be customized?',
        answer: 'Yes, Urbania per km rate in Pune allows flexible pickup and drop locations as per customer preference.',
    },
    {
        question: 'What payment options are available?',
        answer: 'Urbania per km rate in Pune accepts UPI, debit/credit cards, bank transfers, digital wallets, and corporate billing.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey for a smooth experience.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rakesh More',
        feedback: 'We booked Urbania per km rate in Pune for an outstation trip. Pricing was transparent and the journey was very comfortable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Anjali Patil',
        feedback: 'Urbania per km rate in Pune was perfect for our group travel. Clean vehicle, professional driver, and no hidden charges.',
        rating: 5,
    },
];







































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania per km rate in Pune",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-per-km-rate-pune.jpg",
  "description": "Urbania per km rate in Pune provides transparent pricing for AC and non-AC Urbania buses. Ideal for city travel, outstation trips, corporate travel, and family tours, ensuring affordable, comfortable, and chauffeur-driven Urbania bus service in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "15",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-per-km-rate-pune"
  }
};



    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania per km rate in Pune | Affordable AC & Non-AC Urbania Hire 
  </title>

  <meta
    name="description"
    content="Check Urbania per km rate in Pune for AC and non-AC buses. Transparent pricing for city travel, outstation trips, corporate transfers, and family tours with chauffeur-driven service ensures affordable and comfortable Urbania bus rentals in Pune."
  />

  <meta
    name="keywords"
    content="Urbania per km rate in Pune, Urbania Hire Price per km Pune, Urbania Rental Charges Pune, Urbania Bus Fare Pune, Urbania AC Bus Rate Pune, Urbania Non AC Bus Rate Pune, Affordable Urbania Rate Pune, Corporate Urbania Pricing Pune, Outstation Urbania Rate Pune, Urbania Cost per km Pune, Best Urbania Price Pune, Transparent Urbania Fare Pune, Urbania Rental Tariff Pune, Budget Urbania Hire Pune, Urbania Price List Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/51.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaperkmrateinoune;